<template>
    <div>
      <main>
        <!-- 麵包屑 -->
        <section class="container" data-aos="fade-down"  data-aos-delay="500">
          <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" class="badge">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
              <li class="breadcrumb-item" aria-current="page"><router-link to="unintended-2">我意外懷孕了</router-link></li>
              <li class="breadcrumb-item" aria-current="page"><router-link to="unintended-3-1">我想要生下來</router-link></li>
              <li class="breadcrumb-item" aria-current="page"><router-link to="economy-4-1">經濟需求</router-link></li>
              <li class="breadcrumb-item active" aria-current="page"><router-link to="">就業問題</router-link></li>
            </ol>
          </nav>
        </section>

        <!-- 主要區塊 -->
        <section class="container step-rwd">
          <div class="step">
            <!-- 裝飾用圖片 -->
            <img class="step-circle" src="../../assets/image/front/image_circleword.svg">
            <img class="image1" src="../../assets/image/front/page02_image1.svg">
            <img class="image2" src="../../assets/image/front/page02_image2.svg">
            <img class="image3" src="../../assets/image/front/page02_image3.svg">
            <!-- 結束 -->
            <div class="text-box">
              <p class="step-text" data-aos="fade-up" >ANSEWR</p>
              <h2 class="step-title" data-aos="fade-up" >選擇・答案</h2>
              <img class="title-line" src="../../assets/image/front/choose_title_line.svg" data-aos="fade-up" >
              <p class="step-sologan" data-aos="fade-up" >為自己所想，為自己所選。</p>
            </div>
            <div class="container step-box">
              <div class="step-box-inner">
                <div class="box-title" data-aos="fade-up">
                  <h2>｜生活就業問題｜</h2>
                </div>
                <div class="select-menu">
                  <img class="mb-60" data-aos="fade-up" src='../../assets/image/front/page02_pic3.jpg'>
                  <hr data-aos="fade-up">
                    <!-- 選項開始 -->
                    <ul class="select-item container-inner mt-60">
                      <li data-aos="fade-up">
                        <h3>生活層面</h3>
                        <p>孩子一出生接踵而來的就是奶粉錢、尿布錢、褓母費及各樣嬰兒用品的開 銷，若小孩抵抗力較弱，需要三天兩頭就醫，醫療費用也是很可觀的，而如果家人並不支持單親留養，你需要在外租屋，房租也會是固定大筆的支出，以上還不包含你個人的生活費用喔！所以你需要好好精算，目前的收入和存款是否足夠支付接連每個月所需的開銷，學習開源節流，調整自己的消費習慣，做好家庭金錢規劃。</p>
                      </li>
                      <li data-aos="fade-up">
                        <h3>就業問題</h3>
                        <p>你可以申請勞動部所規劃的「職前訓練」，幫助你培養一技之長。在訓練期間也不用擔心生活費，只要你是獨自撫養小孩，或是符合低收入戶的標準，都可以申請職訓生活津貼補助，補助金額為每月基本工資百分之六十。<br>
                        補助條件為：需參加「全日制職業訓練」，並符合四個條件，即可申請。<br>
                          (一)、訓練期間1個月以上 <br>
                          (二)、每星期訓練4日以上<br>
                          (三)、每日訓練日間4小時以上<br>
                          (四)、每月總訓練時數達100小時以上<br><br>
                          建議你可以至
                          <a class="fs-5 text-danger" href="https://www.taiwanjobs.gov.tw/home109/index.aspx" target="_blank">台灣就業通</a>
                           獲得更多完整資訊。 </p>
                      </li>
                      <li data-aos="fade-up">
                        <h3>繼續完成學業</h3>
                        <p>為保障學生受教權，校方必須主動依學籍和成績評量等相關規定來做輔導，讓學生能夠在非預期懷孕後，回歸學校時再次適應學習環境，並依照他們的情況來調整彈性措施，讓面臨非預期懷孕的學生能夠順利完成學業。</p>
                      </li>
                      <li data-aos="fade-up">
                        <h3>急難紓困金（原馬上關懷專案）</h3>
                        <p>
                          福利諮詢專線：1957。<br><br>
                          當家中負擔家庭主要生計的人死亡、失蹤、罹患重傷病、失業或因其他原因無法工作，導致家庭生活陷於困境時，就可以在事件發生的3個月內，向政府申請急難救助。<br>
                          只要民眾本人或親人，甚至是鄰里、村里長、學校等單位發現有急難救助需求的人時，都可以準備急難紓困申請書或通報表，向里辦公室、區公所或市政府申請或通報。<br>
                          訪視小組在通報後24小時內即會進行實地訪視，送核定機關當日核定後24小時內發放關懷救助金1~3萬元；若經過認定屬急迫個案，訪視時會立即先發給5,000元救助金。 若經救助無法紓困或不符規定，民眾可以再去申請地方政府、中央政府救助。
                        </p>
                      </li>
                      <li data-aos="fade-up">
                        <h3>民間補助</h3>
                        <p>
                          除了公家機關之補助外，還可以申請民間單位的補助，相較於公家機關的公文往返時間過長，民間單位反而能夠給予較快的補助流程，能彌補政府所不足的部份，也做為第一線的救助，只是有些補助不能同時申請，所以在申請的時候需特別留意。<br><br>
                          <a class="fs-5 text-danger" href="https://dep.mohw.gov.tw/DOSAASW/cp-598-5104-103.html" target="_blank">《急難救助之服務項目及聯絡窗口》</a><br>
                          （113年1月11日更新)<br>
                          <table border="0" cellspacing="0">
<tbody>
<tr>
<td style="background-color: #ffc000; padding-left: 10px; padding-right: 5px;">
<h2><strong>民間補助</strong></h2>
</td>
<td style="background-color: #ffc000; padding-left: 10px; padding-right: 5px;">
<h2><strong>電話</strong></h2>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人中華民國佛教慈濟慈善事業基金會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>0800-787080</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人法鼓山社會福利慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>（02）2893-9966</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人佛光山慈悲社會福利基金會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>（07）2911237</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人全聯慶祥慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>1. 台北總會 02-8509-5188<br />2. 雙北區辦 02-8501-5095【台北市、新北市、基隆市、宜蘭縣】<br />3. 桃園區辦 03-392-2881【桃園市】<br />4. 苗栗區辦 037-352-928【新竹縣市、苗栗縣】<br />5. 台中區辦 04-2241-1096【台中市、南投縣、彰化縣、金門縣、馬祖】<br />6. 嘉義區辦 05-2911-049 【嘉義縣市、雲林縣、澎湖縣】<br />7. 台南區辦 06-290-0476【台南市】<br />8. 高雄區辦 07-740-5725 【高雄市】<br />9. 屏東區辦 08-733-0196【屏東縣、小琉球】<br />10.花蓮區辦 03-854-2489【花蓮縣】<br />11.台東區辦 089- 355-780【台東縣、蘭嶼、綠島】</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人台北行天宮</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>0800-217-855、（02）2502-6606</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>富邦慈善基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>（02）6638-7885分機715 （急難救助組）</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人兆豐慈善基金會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>（02）2563-3156 轉3781</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人萬海航運社會福利慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p><a href="https://wanhai-charity.org.tw/emergency-aid/">急難救助 | 急難救助金|愛心捐款|志工活動|萬海航運慈善基金會 (wanhai-charity.org.tw)</a></p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>社團法人中華基督教救助協會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>北區 02-8660-9995轉 190<br />桃竹苗 03-5721414<br />中彰投 04-22977590<br />雲嘉南 05-2911119<br />高屏 07-3803755<br />花蓮 038-8315081<br />台東 089-342641、089-342700</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人張榮發慈善基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>(02)2351-9797 轉6204</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>社團法人台灣公益服務協會</strong><strong>(</strong><strong>智邦公益館</strong><strong>)</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>急難救助通報專線：（03）666-8995</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人臺北市永慶社會福利慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>急難救助專線：（02）2709-2997</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>信義公益基金會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>02-2755-7666 轉</p>
<p>2333</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人台灣省私立統一企業社會福利慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>（06）253-6789轉 8326、8332</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>中華民國紅十字會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>服務專線：(02)2302-8595</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人政慧發展會福利慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>（02）2517-2068轉 18</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人台北市李連來公益基金會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>（02）2523-2422</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人永瑞慈善事業基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>（02）2507-8870</p>
</td>
</tr>
<tr>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人臺北市傳德慈善基金會</strong></p>
</td>
<td style="background-color: #fff2cc; padding-left: 10px; padding-right: 5px;">
<p>（02）7751-6956</p>
</td>
</tr>
<tr>
<td style="padding-left: 10px; padding-right: 5px;">
<p><strong>財團法人寶佳公益慈善基金會</strong></p>
</td>
<td style="padding-left: 10px; padding-right: 5px;">
<p>（02）2793-0028</p>
</td>
</tr>
</tbody>
</table>
                        </p>
                        <!--<div class="google-rwd">
                            <iframe src="https://www.google.com/maps/d/embed?mid=16KB92Kb7JwRarrx8WrUjoOWIEnOZDzcj&hl=zh-TW" width="640" height="480"></iframe>
                        </div>-->
                      </li>
                    </ul>
                    <!-- 選項結束 -->
                    <hr data-aos="fade-up">
                    <div data-aos="fade-up">
                      <a class="goBack" onclick="history.back()" value="回到上一頁">回到上一頁</a>
                      <a class="goBack" href="#">返回首頁</a>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Consult></Consult>
        <Circle></Circle>
      </main>
    </div>
</template>
<script>
import Consult from '../../components/Consult.vue'
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  components: {
    Consult
  }
}
</script>
